module.exports = __webpack_public_path__ + "static/media/result-bar-large.eb7ab9c4.svg";